import { useEffect } from "react";

declare global {
  interface Window {
    documentReady?: boolean;
    documentError?: string;
  }
}

export function usePrintDocument(ready: boolean, error: unknown = null): void {
  useEffect(() => {
    if (null !== error && undefined !== error) {
      const thrown = error instanceof Error ? error : new Error(String(error));

      window.documentError = thrown.message;

      setTimeout(() => {
        throw thrown;
      });

      return;
    }

    if (!ready) {
      return;
    }

    let cancelled = false;

    void document.fonts.ready.then(() => {
      if (!cancelled) {
        window.documentReady = true;
      }
    });

    return () => {
      cancelled = true;
    };
  }, [ready, error]);
}
